import { EducationalOrganizationsOptimizedSchema, EducationalOrganizationsSchema } from '../types';
import axiosInstance from './client';

export async function fetchOrganizations() {
    const response = await axiosInstance.get('/educational-organizations/optimized');
    const data = response.data;

    const parsed = EducationalOrganizationsOptimizedSchema.array().safeParse(data);

    if(!parsed.success) {
        const errorDetails = parsed.error.issues
            .map(issue => `${issue.path.join('.')}: ${issue.message}`)
            .join('; ');
        throw new Error(`Organization data validation error: ${errorDetails}`);
    }

    return parsed.data;
}

export async function getOrganizationById(id: string) {
    const response = await axiosInstance.get(`/educational-organizations/${id}`, {
        timeout: 7000
    });
    const data = response.data;

    const parsed = EducationalOrganizationsSchema.safeParse(data);

    if(!parsed.success) {
        const errorDetails = parsed.error.issues
            .map(issue => `${issue.path.join('.')}: ${issue.message}`)
            .join('; ');
        throw new Error(`Organization (${id}) data validation error: ${errorDetails}`);
    }

    return parsed.data;
}
